import React from "react";
import Banner from "../../components/common/banner/banner";
import { Images } from "../../assets";
import MetaTags from "../../components/metaTags/seoTags";
import PageStats from "../../components/pageStats/pageStats";
import BreadcrumbSec from "../../components/common/breadcrumb/breadcrumb";
import { Col, Container, Image, Row } from "react-bootstrap";
import ActionFeedback from "../../components/common/takeActions/actionFeedback";
import { useTranslation } from "react-i18next";

const ApplyExpert = () => {
  const { t } = useTranslation();

  return (
    <>
      <MetaTags
        title={t("applyExpert.metaTitle")}
        metaTitle={t("applyExpert.metaTitle")}
        description={t("applyExpert.metaTitle")}
        keywords={t("applyExpert.metaTitle")}
      />
      <Banner
        img={Images?.mediationBanner}
        title={t("applyExpert.metaTitle")}
        content={t("applyExpert.bannerContent")}
        loader={false}
        addButton={{
          enabled: true,
          secondButton: {
            text: t("applyExpert.metaTitle"),
            link: "#",
          },
        }}
      />
      <BreadcrumbSec
        crumbs={[
          { label: t("nav.home"), link: "/" },
          { label: t("nav.applyExpert") },
        ]}
      />
      <section className="common-section py-100">
        <Container>
          <Row className="align-items-center justify-content-between">
            <Col lg={7}>
              <h2 className="mb-3">{t("applyExpert.section1.title")}</h2>
              <p>{t("applyExpert.section1.description1")}</p>
              <p>{t("applyExpert.section1.description2")}</p>
            </Col>
            <Col lg={4}>
              <div className="image-wrapper mb-lg-0 mb-4">
                <Image
                  src={Images.FacilitiesSlide4} // Optional: Add a new image if needed
                  alt={t("applyExpert.section1.imageAlt")}
                  loading="lazy"
                  fluid
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="common-section py-100 pt-0">
        <Container>
          <Row className="align-items-center justify-content-between">
            <Col lg={4}>
              <div className="image-wrapper mb-lg-0 mb-4">
                <Image
                  src={Images.FacilitiesSlide2}
                  alt={t("applyExpert.fees.imageAlt")}
                  loading="lazy"
                  fluid
                />
              </div>
            </Col>
            <Col lg={7}>
              <h2 className="mb-3">{t("applyExpert.fees.title")}</h2>
              <p className="mb-0">
                <strong>{t("applyExpert.fees.membersLabel")}</strong>{" "}
                {t("applyExpert.fees.membersValue")}
                <br /> <strong>{t("applyExpert.fees.minimumLabel")}</strong> AED
                500 &nbsp;&nbsp;
                <strong>{t("applyExpert.fees.maximumLabel")}</strong> AED 15,000
              </p>
              <p>
                <strong>{t("applyExpert.fees.nonMembersLabel")}</strong>{" "}
                {t("applyExpert.fees.nonMembersValue")}
                <br /> <strong>{t("applyExpert.fees.minimumLabel")}</strong> AED
                1,000 &nbsp;&nbsp;
                <strong>{t("applyExpert.fees.maximumLabel")}</strong> AED 20,000
              </p>
              <h5>{t("applyExpert.fees.vat")}</h5>
              <p className="mb-0">{t("applyExpert.fees.description")}</p>
              <p className="fst-italic">{t("applyExpert.fees.note")}</p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="common-section py-0">
        <Container>
          <Row className="align-items-center justify-content-between">
            <Col lg={7}>
              <h2 className="mb-3">{t("applyExpert.section2.title")}</h2>
              <p>{t("applyExpert.section2.description1")}</p>
              <p>{t("applyExpert.section2.description2")}</p>
            </Col>
            <Col lg={4}>
              <div className="image-wrapper mb-lg-0 mb-4">
                <Image
                  src={Images.FacilitiesSlide4} // Optional: Add a new image if needed
                  alt={t("applyExpert.section2.imageAlt")}
                  loading="lazy"
                  fluid
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="common-section py-100">
        <Container>
          <Row className="align-items-center justify-content-between">
            <Col lg={4}>
              <div className="image-wrapper mb-lg-0 mb-4">
                <Image
                  src={Images.FacilitiesSlide3}
                  alt={t("applyExpert.requirements.imageAlt")}
                  loading="lazy"
                  fluid
                />
              </div>
            </Col>
            <Col lg={7}>
              <h2 className="mb-3">{t("applyExpert.requirements.title")}</h2>
              <p>{t("applyExpert.requirements.description")}</p>
              <ul className="general-list">
                <li>{t("applyExpert.requirements.item1")}</li>
                <li>{t("applyExpert.requirements.item2")}</li>
                <li>{t("applyExpert.requirements.item3")}</li>
                <li>{t("applyExpert.requirements.item4")}</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      <ActionFeedback
        updatedAt={t("applyExpert.updatedAt")}
        pageViewCount="12"
        loader={false}
      />
    </>
  );
};

export default ApplyExpert;
